import "../stylesheets/App.css";
import "../stylesheets/Register.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PopupRegister from "./subcomponents/PopupRegister.js";
import Loader from "./subcomponents/Loader.js";

function Register() {
  const navigate = useNavigate();

  const [loadingRegister, setLoadingRegister] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [name, setName] = useState("");
  const [cedula, setCedula] = useState("");
  const [age, setAge] = useState("");
  const [phone, setPhone] = useState("");
  const [clientNumber, setClientNumber] = useState("");
  const [clientNumberError, setClientNumberError] = useState(false);

  const [marketing, setMarketing] = useState("FB");
  const [idCountry, setIdCountry] = useState(1);

  const [acepto, setAcepto] = useState(false);

  const [activePopup, setActivePopup] = useState(false);
  const [user, setUser] = useState({});

  // STATES TO SHOW ERRORS
  const [nameError, setNameError] = useState(false);
  const [cedulaError, setCedulaError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [ageError, setAgeError] = useState(false);
  const [aceptoError, setAceptoError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const [showPass, setShowPass] = useState(false);

  // fondo exclusivo de register
    useEffect(() => {
      document.body.classList.add("register-page");
      return () => document.body.classList.remove("register-page");
    }, []);

  // ✅ redirect seguro (no en render)
  useEffect(() => {
    const raw = localStorage.getItem("user-info");
    if (!raw) return;

    const parsed = JSON.parse(raw);
    if (parsed?.is_admin) navigate("/admin");
    else navigate("/");
  }, [navigate]);

  useEffect(() => {
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "auto";
  }, []);

  // SAVE USER
  const register = async () => {
    setLoadingRegister(true);
    setErrorMsg("");

    setNameError(false);
    setCedulaError(false);
    setPhoneError(false);
    setClientNumberError(false);
    setEmailError(false);
    setAgeError(false);
    setAceptoError(false);
    setPasswordError(false);

    const idCategory = 1;

    const passwordOk = password && password.length >= 8 && password.length <= 12;

    // ✅ validaciones front (early return)
    if (!name || !cedula || !email || !age || !phone || !clientNumber || !idCountry || !passwordOk || !acepto) {
      setNameError(!name);
      setCedulaError(!cedula);
      setPhoneError(!phone);
      setClientNumberError(!clientNumber);
      setEmailError(!email);
      setAgeError(!age);
      setAceptoError(!acepto);
      setPasswordError(!passwordOk);
      setErrorMsg("Debe completar todos los campos");
      setLoadingRegister(false);
      return;
    }

    const item = {
      name,
      cedula,
      email,
      age,
      phone: phone.toString().startsWith("+506") ? phone : "+506" + phone.toString(),
      client_number: clientNumber,
      marketing,
      idCountry,
      password,
      idCategory,
      acepto,
    };

    try {
      let result = await fetch(process.env.REACT_APP_API_BASE_URL + "/users/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      const json = await result.json();

      if (json.status === 200) {
        setUser(json.data);
        setActivePopup(true);

        // envío mail validación
        await fetch(process.env.REACT_APP_API_BASE_URL + "/users/sendMailValidate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        });

        localStorage.setItem("user-email", JSON.stringify(json.data.email));
      } else {
        const msg = json?.data?.errors?.[0]?.msg || "Error al registrar";
        setErrorMsg(msg);

        if (msg === "El email ingresado ya está en uso. Iniciá sesión!") {
          setEmailError(true);
        }
      }
    } catch (e) {
      console.log(e);
      setErrorMsg("Error de red, intentá de nuevo");
    } finally {
      setLoadingRegister(false);
    }
  };

  return (
    <>
      <div className="back-container">
        <div className="register-container section-70">
          <img className="banner-reg" src={process.env.PUBLIC_URL + "/images/register/Register-Banner.png"} />
          <img
            className="tittle-login"
            src={process.env.PUBLIC_URL + "/images/register/Register-Title.png"}
            alt=""
          />
          {/* NOMBRE */}
          <div className="inp">
            <input
              className="inp-reg"
              type="text"
              placeholder="Nombre completo"
              id="name"
              name="name"
              value={name}
              onChange={(e) => {
                const result = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ ]/g, "");
                setName(result);
              }}
            />
            {nameError && (
              <>
                <div className="error-message">Por favor agrega el nombre completo</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* ID */}
          <div className="inp">
            <input
              className="inp-reg"
              type="number"
              placeholder="Número de identificación"
              id="cedula"
              name="cedula"
              onChange={(e) => setCedula(e.target.value)}
            />
            {cedulaError && (
              <>
                <div className="error-message">Por favor agrega número de identificación</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* TELÉFONO */}
          <div className="inp">
            <input
              className="inp-reg"
              type="number"
              placeholder="Número de teléfono"
              id="phone"
              name="phone"
              onChange={(e) => setPhone(e.target.value)}
            />
            {phoneError && (
              <>
                <div className="error-message">Por favor agrega número de teléfono</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* NÚMERO DE CLIENTE */}
          <div className="inp">
            <input
              className="inp-reg"
              type="text"
              placeholder="Número de cliente"
              id="clientNumber"
              name="clientNumber"
              value={clientNumber}
              onChange={(e) => {
                const result = e.target.value.replace(/\D/g, "");
                setClientNumber(result);
              }}
            />
            {clientNumberError && (
              <>
                <div className="error-message">Por favor agrega el número de cliente</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* EMAIL */}
          <div className="inp">
            <input
              className="inp-reg"
              type="text"
              placeholder="Correo electrónico"
              id="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailError && (
              <>
                <div className="error-message">Por favor agrega un email válido</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* EDAD */}
          <div className="inp">
            <input
              className="inp-reg"
              type="number"
              placeholder="Edad"
              id="age"
              name="age"
              onChange={(e) => setAge(e.target.value)}
            />
            {ageError && (
              <>
                <div className="error-message">Por favor agregar edad</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* PASS */}
          <div className="inp">
            <input
              className="inp-reg"
              type={showPass ? "text" : "password"}
              placeholder="Contraseña"
              id="password"
              name="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              className="show-pass"
              onClick={() => setShowPass((p) => !p)}
              alt=""
              src={
                process.env.PUBLIC_URL +
                (showPass
                  ? "/images/icons/open-eye.svg"
                  : "/images/icons/close-eye.svg")
              }
            />

            {passwordError && (
              <>
                <div className="error-message">La contraseña debe tener entre 8 y 12 caracteres</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* TERMS */}
          <div className="term-container">
            <input type="checkbox" name="acepto" onChange={(e) => setAcepto(e.target.checked)} />
            <label>
              Aceptar los{" "}
              <a onClick={() => navigate("/privacy-policy")}>
                <strong className="text-azul-brand">Términos y Condiciones</strong>.
              </a>
            </label>

            {aceptoError && (
              <>
                <div className="error-message checkbox-error-message">
                  Debe aceptar los términos y condiciones
                </div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          <span className="error-msg">{errorMsg}</span>

          <div className="login-btn-container">
            <button type="submit" className="btn red-btn mb-4" id="register" onClick={register}>
              Registrarse
            </button>

            <button className="btn blue-btn" id="reg-cancel" onClick={() => navigate("/login")}>
              Cancelar
            </button>
          </div>
          <img className="login-bottom-img" src={process.env.PUBLIC_URL + "/images/login/login-bottom-img.png"}/>
        </div>
      </div>

      {activePopup ? <PopupRegister user={user} /> : null}
      {loadingRegister ? <Loader /> : null}
    </>
  );
}

export default Register;
